import { render, staticRenderFns } from "./KT-Table.vue?vue&type=template&id=18a7a2ae&scoped=true&lang=pug&"
import script from "./KT-Table.vue?vue&type=script&lang=js&"
export * from "./KT-Table.vue?vue&type=script&lang=js&"
import style0 from "./KT-Table.vue?vue&type=style&index=0&id=18a7a2ae&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a7a2ae",
  null
  
)

export default component.exports